export const ROLES = {
  admin: "admin",
  claims_ops: "claims_ops",
  claims_user: "claims_user",
  underwriting: "underwriting",
  csr: "csr",
  agency_support: "agency_support",
  user: "user",
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

const ROLE_VALUES = new Set<string>(Object.values(ROLES));

/** Narrow an unknown role string (from a session, env var, etc.) to a typed
 *  Role. Returns the validated role or `"user"` (least privilege) when the
 *  value isn't a known role. Use this instead of `value as Role` at every
 *  data boundary — including reads from Better Auth's session, which types
 *  the role field as plain `string`. */
export function parseRole(value: unknown): Role {
  if (typeof value === "string" && ROLE_VALUES.has(value)) {
    return value as Role;
  }
  return ROLES.user;
}

/** Roles that can access claim team maintenance and operations pages */
export const CLAIMS_OPS_ROLES: Role[] = [ROLES.admin, ROLES.claims_ops];

/** Roles that can access admin/configuration pages */
export const ADMIN_ROLES: Role[] = [ROLES.admin];

/** Check if a role is in the allowed roles list */
export function hasRole(userRole: unknown, allowedRoles: Role[]): boolean {
  return allowedRoles.includes(parseRole(userRole));
}
